import React from "react";
import {Layout, Tooltip} from "antd";
import {RouteComponentProps, withRouter} from 'react-router-dom';
import cx from 'classnames';

import './styles.scss';

import {IUser} from "../../../api/User/User.types";
import {AppRoutesPathReference, AppSidebarItemsMap} from "../../../routes/RoutesRegister";
import Logo from "../../../assets/logo.png";
import BrowserRouter from "../../../routes/BrowserRouter";
import {LeftOutlined} from "@ant-design/icons";
import {EAppSidebarGroups} from "../../../routes/AppRoutes";
import useAppStore from "../../../data/App.store";
import useUserStore from "../../../data/User.store";

interface Props extends RouteComponentProps {
    logo?: boolean,
}

function AppSidebar(props: Props) {
    const { logo } = props;
    const sidebarCollapsed = useAppStore(state => state.sidebarCollapsed);
    const toggleSidebarCollapsed = useAppStore(state => state.toggleSidebarCollapsed);
    const user = useUserStore(state => state.user);

    function hasAccess(user: IUser, appRouteHeaderAccess: string[]) {
        if (!appRouteHeaderAccess || appRouteHeaderAccess.length === 0) return true

        return appRouteHeaderAccess.find(access => user?.role?.name === access)
    }

    function getSelectedKey() {
        for (let key in AppRoutesPathReference) {

            if (props.location.pathname.includes(AppRoutesPathReference[key].path)) {
                // special case for vendor portfolio pages since the tabs inside the vendor page
                // include routing key words like 'assessments' which confuses the following path check
                if (props.location.pathname.includes('vendors')) {
                    return 'Vendors';
                }
                return key;
            }
        }
        return '';
    }

    function renderMenuItems() {
        if (!user) return;

        let groups = {};
        Object.keys(EAppSidebarGroups).forEach(group => {
            groups[EAppSidebarGroups[group]] = [];
        })

        AppSidebarItemsMap.forEach(appRouteHeader => {
            const {key, icon, path, access, group} = appRouteHeader;
            if (hasAccess(user, access) && group !== "Hidden") {
                groups[group].push(
                    <div key={key} className={cx('sidebar-item', {
                        selected: getSelectedKey() === key,
                        collapsed: sidebarCollapsed
                    })}
                         onClick={() => BrowserRouter.push(path)}>
                        {icon}
                        {!sidebarCollapsed &&
                        <div className='sidebar-item-title'>
                            {key}
                        </div>}
                    </div>
                )
            }
        })

        let groupRender = [];

        Object.keys(groups).forEach(group => {
            const render = groups[group];
            if (render.length > 0) {
                groupRender.push(
                    <div key={group} className='sidebar-group'>
                        {!sidebarCollapsed &&
                        <div className='group-header'>
                            {group}
                        </div>}
                        <div className='sidebar-group-items'>
                            {render}
                        </div>
                    </div>
                )
            }
        })
        return groupRender;
    }

    return (
        <Layout.Sider theme='light' className='app-sidebar' width={250} collapsed={sidebarCollapsed}>
            {logo &&
            <div className='white-logo'>
                {!sidebarCollapsed &&
                <img alt="logo" src={Logo}/>}
                <Tooltip title={`${sidebarCollapsed ? 'Expand' : 'Collapse'} Sidebar`}>
                    <LeftOutlined className={cx('toggle-collapse', {collapsed: sidebarCollapsed})}
                                  onClick={toggleSidebarCollapsed}/>
                </Tooltip>
            </div>}
            <div className='app-sidebar-menu'>
                {renderMenuItems()}
            </div>
            <div className='shadow'/>
        </Layout.Sider>
    )
}

export default withRouter(AppSidebar);